export const PERFORMANCE_MARKS = {
  MAP_TILES_LOADED: 'map:tiles-loaded',
  MAP_VIEW_BUTTON_CLICKED: 'map:view-button-clicked',
} as const
